











































































import {Component, Inject, Mixins} from 'vue-property-decorator';
import {NodeSummaryWidget} from '@v/dashboard/interfaces';
import {requestNodeSummaryData} from '@api/widgetApi';
import NodeSummaryRow from './NodeSummaryRow.vue';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';
import OrNodeSummaryWidgetBindForm from '@c/widgets/base/bindForms/OrNodeSummaryWidgetBindForm.vue';
import {NodeSummaryWidgetIntervalType} from '../base/bindForms/enums';
import {DateTime} from 'luxon';
import WidgetDataTimerMixin from '@/mixins/WidgetDataTimerMixin';

@Component({
  components: {NodeSummaryRow, WidgetBindDataSource, Loading, OrNodeSummaryWidgetBindForm},
})
export default class NodeSummaryComponent extends Mixins(WidgetDataTimerMixin) {
  @Inject()
  widget!: NodeSummaryWidget;

  //Цвет заголовка
  colorCaption = '#e5e5e5';

  nodeId: string | null = null;

  //Наименование узла
  nodeName = '';

  // TODO когда в БД появятся краткие наименования заменить
  get nodeShortName() {
    return this.nodeName;
  }

  //Показатели загрузки и наличия ошибок
  loading = true;
  error = false;

  //Сила последнего детектированного удара
  lastHitStrength: number | null = null;
  lastHitStrengthUnit = '';

  //Высокочастотный шум (0-ая гармоника спектра огибающей)
  zeroEnvelopSpectrumHarm: number | null = null;
  zeroEnvelopSpectrumHarmUnit = '';

  //Потребляемый ток
  energy: number | null = null;
  energyUnit = '';

  //Температура
  temperature: number | null = null;
  temperatureUnit = '';

  //Обороты
  turnovers: number | null = null;
  turnoversUnit = '';

  //TODO: временно убраны
  //Оставшиеся время до ТО (дней)
  //maintenanceRemainingTime: number | null = null;
  //maintenanceRemainingTimeUnit = '';

  //Интегральный показатель жизнеспособности узла в процентах
  //health: number | null = null;
  //healthUnit = '';

  //Временной интервал
  intervalType: NodeSummaryWidgetIntervalType | null = null;

  // Действия при выборе узла
  onNodeSelect(data: {nodeId: string; nodeName: string}) {
    const intervalType = (this.$refs.bindForm as any).intervalType as NodeSummaryWidgetIntervalType;
    this.intervalType = intervalType;

    this.widget.intervalType = intervalType;
    this.widget.nodeId = data.nodeId;
    this.widget.nodeName = data.nodeName;
    this.nodeId = data.nodeId;
    this.nodeName = data.nodeName;

    this.attachNode(this.widget.nodeId, intervalType);
  }

  created() {
    this.getDataTimeout = 3600;
    this.nodeId = this.widget.nodeId;
    this.nodeName = this.widget.nodeName;
    this.intervalType = this.widget.intervalType;
    this.attachNode(this.widget.nodeId, this.widget.intervalType);
  }

  // Привязка узла
  async attachNode(nodeId: string | null, intervalType: NodeSummaryWidgetIntervalType) {
    if (!nodeId) return;
    this.loading = true;
    this.clearRefresh();
    this.refresh(async () => {
      try {
        await this.getData(nodeId, intervalType);
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    });
  }

  async getData(nodeId: string, intervalType: NodeSummaryWidgetIntervalType) {
    this.nodeId = nodeId;
    this.nodeName = this.widget.nodeName;

    const date = Date.now();
    const startDate = Math.floor(
      DateTime.fromMillis(date)
        .minus({
          [intervalType as string]: 1,
        })
        .valueOf(),
    );
    const endDate = date;

    this.error = false;

    const {
      lastHitStrength,
      lastHitStrengthUnit,
      zeroEnvelopSpectrumHarm,
      zeroEnvelopSpectrumHarmUnit,
      energy,
      energyUnit,
      temperature,
      temperatureUnit,
      turnovers,
      turnoversUnit,

      //TODO: временно убраны
      //maintenanceRemainingTime,
      //maintenanceRemainingTimeUnit,
      //health,
      //healthUnit,
    } = await requestNodeSummaryData(nodeId, startDate, endDate);

    this.lastHitStrength = lastHitStrength;
    this.lastHitStrengthUnit = lastHitStrengthUnit != '-' ? lastHitStrengthUnit : '';
    this.zeroEnvelopSpectrumHarm = zeroEnvelopSpectrumHarm;
    this.zeroEnvelopSpectrumHarmUnit =
      zeroEnvelopSpectrumHarmUnit != '-' ? zeroEnvelopSpectrumHarmUnit : '';
    this.energy = energy;
    this.energyUnit = energyUnit != '-' ? energyUnit : '';
    this.temperature = temperature;
    this.temperatureUnit = temperatureUnit != '-' ? temperatureUnit : '';
    this.turnovers = turnovers;
    this.turnoversUnit = turnoversUnit != '-' ? turnoversUnit : '';

    //TODO: временно убраны
    //this.maintenanceRemainingTime = maintenanceRemainingTime;
    //this.maintenanceRemainingTimeUnit = maintenanceRemainingTimeUnit;
    //this.health = health;
    //this.healthUnit = healthUnit;
  }
}
